import * as React from 'react';
import type { ReactNode } from 'react';
import { AppProvider } from '../providers/app-provider';
import { ThemeProvider } from '../providers/theme-provider';
import { TrpcProvider } from '../providers/trpc-provider';
import { Layout } from 'antd';
import { ConnectionProvider } from '../providers/connection-provider';
import { LocaleSyncManager } from '../components/locale-sync-manager';

export function DefaultLayout({ children }: { children: ReactNode }) {
  const { Content } = Layout;

  return (
    <ConnectionProvider>
      <TrpcProvider>
        <LocaleSyncManager />
        <ThemeProvider>
          <AppProvider>
            <Layout className="v-grid main" style={{ height: '100vh' }}>
              <Content className="v-grid">{children}</Content>
            </Layout>
          </AppProvider>
        </ThemeProvider>
      </TrpcProvider>
    </ConnectionProvider>
  );
}
